import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Control from '@/views/Control.vue';
import Layout from '@/views/Layout.vue';
import Integration from '@/views/Integration.vue';
import Consultation from '@/views/Consultation.vue';
import Selection from '@/views/Selection.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import Logout from '@/views/Logout.vue';
import Forbidden from '@/views/Forbidden.vue';
import { authenticationGuard } from './authentication-guard';
import { Role } from '@/router/role-enum';

Vue.use(VueRouter);

export const routes: RouteConfig[] = [
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: Unauthorized
  },
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '/control',
        name: 'control',
        component: Control,
        meta: {
          pageTitle: 'page.control.title',
          authorizedUserRoles: [Role.RECAP_USER, Role.SUPPLIER_USER],
          menuLink: {
            title: 'navigation.links.control',
            icon: 'mdi-check-circle-outline'
          }
        }
      },
      {
        path: '/integration',
        name: 'integration',
        component: Integration,
        meta: {
          pageTitle: 'page.integration.title',
          authorizedUserRoles: [Role.RECAP_USER],
          menuLink: {
            title: 'navigation.links.integration',
            icon: 'mdi-upload-outline'
          }
        }
      },
      {
        path: '/consultation',
        name: 'consultation',
        component: Consultation,
        meta: {
          pageTitle: 'page.consultation.title',
          authorizedUserRoles: [Role.RECAP_USER],
          menuLink: {
            title: 'navigation.links.consultation',
            icon: 'mdi-eye'
          }
        }
      },
      {
        path: '/selection',
        name: 'selection',
        component: Selection,
        meta: {
          pageTitle: 'page.selection.title',
          authorizedUserRoles: [Role.RECAP_USER],
          menuLink: {
            title: 'navigation.links.selection',
            icon: 'mdi-cart-plus'
          }
        }
      },
      {
        path: '/forbidden',
        name: 'forbidden',
        component: Forbidden,
        meta: {
          pageTitle: 'page.forbidden.title'
        }
      },
      {
        path: '*',
        redirect: '/control'
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(authenticationGuard);

export default router;
